import LicenseDetails from "./LicenseDetails";

type FullLicensesDetailsProps = {
    monthlyTokenCount: number;
    monthlySpentTokenCount: number;
    active: LicenseDetails[];
};

export default class FullLicensesDetails {
    monthlyTokenCount: number;

    monthlySpentTokenCount: number;

    active: LicenseDetails[];

    constructor({
        monthlyTokenCount,
        monthlySpentTokenCount,
        active,
    }: FullLicensesDetailsProps) {
        this.monthlyTokenCount = monthlyTokenCount;
        this.monthlySpentTokenCount = monthlySpentTokenCount;
        this.active = active;
    }
}
